import { Show } from "react-admin";
import DoctoralRankingResults from "./components/DoctoralRankingResults";

const ShowDoctoralRankingResults = () => {
  return (
    <Show title="Класиране по места">
      <DoctoralRankingResults />
    </Show>
  );
};

export default ShowDoctoralRankingResults;
